import { render } from "./ligacaoMapas.vue?vue&type=template&id=77748aa8"
import script from "./ligacaoMapas.vue?vue&type=script&lang=js"
export * from "./ligacaoMapas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__